import {bufferTime, catchError, filter, map, mergeMap} from "rxjs/operators";
import {of} from 'rxjs';
import {networkError} from "../actions/ui";
import {combineEpics, ofType} from "redux-observable";
import {
  addBidCalendar,
  addBidStatuses,
  addDailyLogCalendar,
  addDailyLogDetails,
  addDailyLogStatuses,
  addMeetingMinutesDetails,
  addProjectCalendar,
  addProjectRfiCalendar,
  addProjectRfiDetails,
  addProjectRfiStatuses,
  addProjectStatuses,
  addPunchCalendar,
  addPunchStatuses,
  addSubmittalCalendar,
  addSubmittalDetails,
  addSubmittalStatuses,
  addTaskCalendar,
  addTaskDetails,
  addTaskStatuses,
  addUpcomingBidDetails,
  API_GET_REPORT_BID_CALENDAR,
  API_GET_REPORT_BID_CALENDAR_DONE,
  API_GET_REPORT_BID_STATUS,
  API_GET_REPORT_BID_STATUS_DONE,
  API_GET_REPORT_DAILY_LOG_CALENDAR,
  API_GET_REPORT_DAILY_LOG_CALENDAR_DONE,
  API_GET_REPORT_DAILY_LOG_DETAILS,
  API_GET_REPORT_DAILY_LOG_DETAILS_DONE,
  API_GET_REPORT_DAILY_LOG_STATUS,
  API_GET_REPORT_DAILY_LOG_STATUS_DONE,
  API_GET_REPORT_MEETING_MINUTES_DETAILS,
  API_GET_REPORT_MEETING_MINUTES_DETAILS_DONE,
  API_GET_REPORT_PROJECT_CALENDAR,
  API_GET_REPORT_PROJECT_CALENDAR_DONE,
  API_GET_REPORT_PROJECT_RFI_CALENDAR,
  API_GET_REPORT_PROJECT_RFI_CALENDAR_DONE,
  API_GET_REPORT_PROJECT_RFI_DETAILS,
  API_GET_REPORT_PROJECT_RFI_DETAILS_DONE,
  API_GET_REPORT_PROJECT_RFI_STATUS,
  API_GET_REPORT_PROJECT_RFI_STATUS_DONE,
  API_GET_REPORT_PROJECT_STATUS,
  API_GET_REPORT_PROJECT_STATUS_DONE,
  API_GET_REPORT_PUNCH_CALENDAR,
  API_GET_REPORT_PUNCH_CALENDAR_DONE,
  API_GET_REPORT_PUNCH_STATUS,
  API_GET_REPORT_PUNCH_STATUS_DONE,
  API_GET_REPORT_SUBMITTAL_CALENDAR,
  API_GET_REPORT_SUBMITTAL_CALENDAR_DONE,
  API_GET_REPORT_SUBMITTAL_DETAILS,
  API_GET_REPORT_SUBMITTAL_DETAILS_DONE,
  API_GET_REPORT_SUBMITTAL_STATUS,
  API_GET_REPORT_SUBMITTAL_STATUS_DONE,
  API_GET_REPORT_TASK_CALENDAR,
  API_GET_REPORT_TASK_CALENDAR_DONE,
  API_GET_REPORT_TASK_DETAILS,
  API_GET_REPORT_TASK_DETAILS_DONE,
  API_GET_REPORT_TASK_STATUS,
  API_GET_REPORT_TASK_STATUS_DONE,
  API_GET_REPORT_UPCOMING_BID_DETAILS,
  API_GET_REPORT_UPCOMING_BID_DETAILS_DONE,
  getBidCalendarReportDone,
  getBidStatusReportDone,
  getDailyLogCalendarReportDone,
  getDailyLogDetailsReportDone,
  getDailyLogStatusReportDone,
  getMeetingMinutesDetailsReportDone,
  getProjectCalendarReportDone,
  getProjectRfiCalendarReportDone,
  getProjectRfiDetailsReportDone,
  getProjectRfiStatusReportDone,
  getProjectStatusReportDone,
  getPunchCalendarReportDone,
  getPunchStatusReportDone,
  getSubmittalCalendarReportDone,
  getSubmittalDetailsReportDone,
  getSubmittalStatusReportDone,
  getTaskCalendarReportDone,
  getTaskDetailsReportDone,
  getTaskStatusReportDone,
  getUpcomingBidDetailsReportDone
} from "../actions/reports";
import {
  getBidCalendarReports$,
  getBidStatusReports$, getDailyLogCalendarReports$, getDailyLogDetailsReports$,
  getDailyLogStatusReports$, getMeetingMinutesDetailsReports$,
  getProjectCalendarReports$, getProjectRfiCalendarReports$,
  getProjectRfiDetailsReports$,
  getProjectRfiStatusReports$,
  getProjectStatusReports$, getPunchCalendarReports$,
  getPunchStatusReports$, getSubmittalCalendarReports$,
  getSubmittalDetailsReports$,
  getSubmittalStatusReports$, getTaskCalendarReports$,
  getTaskDetailsReports$,
  getTaskStatusReports$,
  getUpcomingBidDetailsReports$
} from "../services/reports";
import {catchErrorsandResume, MODEL_INSERTION_BUFFER_INTERVAL_MS} from "./index";

// Functions

const getReportEpic = number => (action$, reportAction, reportObservable$, reportDoneAction) => action$.pipe(
  ofType(reportAction),
  mergeMap(action => reportObservable$(action.payload).pipe(
    map(({response}) => reportDoneAction((response != null) ? response.results : [])),
    catchError(error => of(networkError({...error, number: `10094-${number}-${error.status}`})))
  )),
  catchErrorsandResume(`20048-${number}`)
);

const processReportEpic = number => (action$, reportAction, addReportAction) => action$.pipe(
  ofType(reportAction),
  map(action => action.payload),
  bufferTime(MODEL_INSERTION_BUFFER_INTERVAL_MS),
  filter(results => results.length > 0),
  map(results => addReportAction(results)),
  catchErrorsandResume(`20049-${number}`)
);

// Statuses

const getBidStatusEpic = action$ => getReportEpic(30002)(action$, API_GET_REPORT_BID_STATUS, getBidStatusReports$, getBidStatusReportDone);
const processBidStatusEpic = action$ => processReportEpic(30002)(action$, API_GET_REPORT_BID_STATUS_DONE, addBidStatuses);
const getProjectStatusEpic = action$ => getReportEpic(30011)(action$, API_GET_REPORT_PROJECT_STATUS, getProjectStatusReports$, getProjectStatusReportDone);
const processProjectStatusEpic = action$ => processReportEpic(30011)(action$, API_GET_REPORT_PROJECT_STATUS_DONE, addProjectStatuses);
const getProjectRfiStatusEpic = action$ => getReportEpic(30010)(action$, API_GET_REPORT_PROJECT_RFI_STATUS, getProjectRfiStatusReports$, getProjectRfiStatusReportDone);
const processProjectRfiStatusEpic = action$ => processReportEpic(30010)(action$, API_GET_REPORT_PROJECT_RFI_STATUS_DONE, addProjectRfiStatuses);
const getSubmittalStatusEpic = action$ => getReportEpic(30016)(action$, API_GET_REPORT_SUBMITTAL_STATUS, getSubmittalStatusReports$, getSubmittalStatusReportDone);
const processSubmittalStatusEpic = action$ => processReportEpic(30016)(action$, API_GET_REPORT_SUBMITTAL_STATUS_DONE, addSubmittalStatuses);
const getTaskStatusEpic = action$ => getReportEpic(30019)(action$, API_GET_REPORT_TASK_STATUS, getTaskStatusReports$, getTaskStatusReportDone);
const processTaskStatusEpic = action$ => processReportEpic(30019)(action$, API_GET_REPORT_TASK_STATUS_DONE, addTaskStatuses);
const getPunchStatusEpic = action$ => getReportEpic(30013)(action$, API_GET_REPORT_PUNCH_STATUS, getPunchStatusReports$, getPunchStatusReportDone);
const processPunchStatusEpic = action$ => processReportEpic(30013)(action$, API_GET_REPORT_PUNCH_STATUS_DONE, addPunchStatuses);
const getDailyLogStatusEpic = action$ => getReportEpic(30005)(action$, API_GET_REPORT_DAILY_LOG_STATUS, getDailyLogStatusReports$, getDailyLogStatusReportDone);
const processDailyLogStatusEpic = action$ => processReportEpic(30005)(action$, API_GET_REPORT_DAILY_LOG_STATUS_DONE, addDailyLogStatuses);

// Calendar

const getBidCalendarEpic = action$ => getReportEpic(30001)(action$, API_GET_REPORT_BID_CALENDAR, getBidCalendarReports$, getBidCalendarReportDone);
const processBidCalendarEpic = action$ => processReportEpic(30001)(action$, API_GET_REPORT_BID_CALENDAR_DONE, addBidCalendar);
const getProjectCalendarEpic = action$ => getReportEpic(30007)(action$, API_GET_REPORT_PROJECT_CALENDAR, getProjectCalendarReports$, getProjectCalendarReportDone);
const processProjectCalendarEpic = action$ => processReportEpic(30007)(action$, API_GET_REPORT_PROJECT_CALENDAR_DONE, addProjectCalendar);
const getProjectRfiCalendarEpic = action$ => getReportEpic(30008)(action$, API_GET_REPORT_PROJECT_RFI_CALENDAR, getProjectRfiCalendarReports$, getProjectRfiCalendarReportDone);
const processProjectRfiCalendarEpic = action$ => processReportEpic(30008)(action$, API_GET_REPORT_PROJECT_RFI_CALENDAR_DONE, addProjectRfiCalendar);
const getSubmittalCalendarEpic = action$ => getReportEpic(30014)(action$, API_GET_REPORT_SUBMITTAL_CALENDAR, getSubmittalCalendarReports$, getSubmittalCalendarReportDone);
const processSubmittalCalendarEpic = action$ => processReportEpic(30014)(action$, API_GET_REPORT_SUBMITTAL_CALENDAR_DONE, addSubmittalCalendar);
const getTaskCalendarEpic = action$ => getReportEpic(30017)(action$, API_GET_REPORT_TASK_CALENDAR, getTaskCalendarReports$, getTaskCalendarReportDone);
const processTaskCalendarEpic = action$ => processReportEpic(30017)(action$, API_GET_REPORT_TASK_CALENDAR_DONE, addTaskCalendar);
const getPunchCalendarEpic = action$ => getReportEpic(30012)(action$, API_GET_REPORT_PUNCH_CALENDAR, getPunchCalendarReports$, getPunchCalendarReportDone);
const processPunchCalendarEpic = action$ => processReportEpic(30012)(action$, API_GET_REPORT_PUNCH_CALENDAR_DONE, addPunchCalendar);
const getDailyLogCalendarEpic = action$ => getReportEpic(30003)(action$, API_GET_REPORT_DAILY_LOG_CALENDAR, getDailyLogCalendarReports$, getDailyLogCalendarReportDone());
const processDailyLogCalendarEpic = action$ => processReportEpic(30003)(action$, API_GET_REPORT_DAILY_LOG_CALENDAR_DONE, addDailyLogCalendar);

// Details

const getUpcomingBidDetailsEpic = action$ => getReportEpic(30020)(action$, API_GET_REPORT_UPCOMING_BID_DETAILS, getUpcomingBidDetailsReports$, getUpcomingBidDetailsReportDone);
const processUpcomingBidDetailsEpic = action$ => processReportEpic(30020)(action$, API_GET_REPORT_UPCOMING_BID_DETAILS_DONE, addUpcomingBidDetails);
const getProjectRfiDetailsEpic = action$ => getReportEpic(30009)(action$, API_GET_REPORT_PROJECT_RFI_DETAILS, getProjectRfiDetailsReports$, getProjectRfiDetailsReportDone);
const processProjectRfiDetailsEpic = action$ => processReportEpic(30009)(action$, API_GET_REPORT_PROJECT_RFI_DETAILS_DONE, addProjectRfiDetails);
const getSubmittalDetailsEpic = action$ => getReportEpic(30015)(action$, API_GET_REPORT_SUBMITTAL_DETAILS, getSubmittalDetailsReports$, getSubmittalDetailsReportDone);
const processSubmittalDetailsEpic = action$ => processReportEpic(30015)(action$, API_GET_REPORT_SUBMITTAL_DETAILS_DONE, addSubmittalDetails);
const getTaskDetailsEpic = action$ => getReportEpic(30018)(action$, API_GET_REPORT_TASK_DETAILS, getTaskDetailsReports$, getTaskDetailsReportDone);
const processTaskDetailsEpic = action$ => processReportEpic(30018)(action$, API_GET_REPORT_TASK_DETAILS_DONE, addTaskDetails);
const getDailyLogDetailsEpic = action$ => getReportEpic(30004)(action$, API_GET_REPORT_DAILY_LOG_DETAILS, getDailyLogDetailsReports$, getDailyLogDetailsReportDone);
const processDailyLogDetailsEpic = action$ => processReportEpic(30004)(action$, API_GET_REPORT_DAILY_LOG_DETAILS_DONE, addDailyLogDetails);
const getMeetingMinutesDetailsEpic = action$ => getReportEpic(30006)(action$, API_GET_REPORT_MEETING_MINUTES_DETAILS, getMeetingMinutesDetailsReports$, getMeetingMinutesDetailsReportDone);
const processMeetingMinutesDetailsEpic = action$ => processReportEpic(30006)(action$, API_GET_REPORT_MEETING_MINUTES_DETAILS_DONE, addMeetingMinutesDetails);

// Export

export const reportsEpic = combineEpics(
  getBidStatusEpic,
  processBidStatusEpic,
  getProjectStatusEpic,
  processProjectStatusEpic,
  getProjectRfiStatusEpic,
  processProjectRfiStatusEpic,
  getSubmittalStatusEpic,
  processSubmittalStatusEpic,
  getTaskStatusEpic,
  processTaskStatusEpic,
  getPunchStatusEpic,
  processPunchStatusEpic,
  getUpcomingBidDetailsEpic,
  processUpcomingBidDetailsEpic,
  getProjectRfiDetailsEpic,
  processProjectRfiDetailsEpic,
  getSubmittalDetailsEpic,
  processSubmittalDetailsEpic,
  getTaskDetailsEpic,
  processTaskDetailsEpic,
  getDailyLogDetailsEpic,
  processDailyLogDetailsEpic,
  getMeetingMinutesDetailsEpic,
  processMeetingMinutesDetailsEpic,
  getDailyLogStatusEpic,
  processDailyLogStatusEpic,
  getBidCalendarEpic,
  processBidCalendarEpic,
  getProjectCalendarEpic,
  processProjectCalendarEpic,
  getProjectRfiCalendarEpic,
  processProjectRfiCalendarEpic,
  getSubmittalCalendarEpic,
  processSubmittalCalendarEpic,
  getTaskCalendarEpic,
  processTaskCalendarEpic,
  getPunchCalendarEpic,
  processPunchCalendarEpic,
  getDailyLogCalendarEpic,
  processDailyLogCalendarEpic,
);


// WEBPACK FOOTER //
// ./src/network/reports.js